import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { PieceExternalProviderAppsRenderComponent } from './piece-external-provider-apps-render.component';


export const pieceExternalProviderAppsRenderModuleEntryComponents = [
  PieceExternalProviderAppsRenderComponent
];

@NgModule({
  imports: [
    RenderSharedModule,
    RenderBlocksModule,
    SharedModule
  ],
  declarations: pieceExternalProviderAppsRenderModuleEntryComponents
})
export class PieceExternalProviderAppsRenderModule {}

export default pieceExternalProviderAppsRenderModuleEntryComponents;
